import { render, staticRenderFns } from "./CustomerActivityDisplay.vue?vue&type=template&id=d1a589ac"
import script from "./CustomerActivityDisplay.vue?vue&type=script&lang=js"
export * from "./CustomerActivityDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports